module.exports = __webpack_public_path__ + "static/media/logo.9b49b082.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 506
// module chunks = 0